import { Component, NgModule, ViewEncapsulation, ElementRef, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyTheme } from './theme.service';
import { Platform } from './platform/index';
var id = 0;
var LyRoot = /** @class */ (function () {
    function LyRoot(elementRef, theme) {
        var _this = this;
        this.elementRef = elementRef;
        this.theme = theme;
        this.themeSubscription = this.theme.palette.subscribe(function (palette) {
            _this.backgroundStyle = palette['bgText'];
            _this.colorStyle = palette['colorText'];
            _this.fontFamily = theme.AlyleUI.currentTheme.typography.fontFamily;
        });
    }
    LyRoot.prototype.ngOnDestroy = function () {
        this.themeSubscription.unsubscribe();
    };
    LyRoot.decorators = [
        { type: Component, args: [{
                    selector: 'ly-core[root]',
                    template: "\n  <ng-content></ng-content>\n  ",
                    styles: ["html, body { width: 100%; height: 100%; } body { margin: 0; } ly-core[root] { display: block; position: relative; } ly-svg svg, [ly-svg] svg { width: inherit; height: inherit; fill: currentColor; display: block; } @keyframes btnFocusAnim { from { transform: scale(0.6); } 50% { transform: scale(0.8); } to { transform: scale(0.6); } } [ly-ripple] > ly-hover-container { position: absolute; top: 0; left: 0; background: currentColor; opacity: 0; transform: scale3d(0, 0, 0); transition: all 0ms cubic-bezier(0.45, 0, 0.25, 1); border-radius: 100%; } button { -webkit-tap-highlight-color: transparent; } [ly-icon-button] > .ly-icon-button-container > .ly-icon-button-content > ly-hover-container { background: -moz-radial-gradient(center, ellipse cover, currentColor 0%, transparent 100%); /* FF3.6-15 */ background: -webkit-radial-gradient(center, ellipse cover, currentColor 0%, transparent 100%); /* Chrome10-25,Safari5.1-6 */ background: radial-gradient(ellipse at center, currentColor 0%, transparent 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */ } [ly-ripple]:not(.ly-ripple-no-focus):focus > ly-hover-container, [ly-button]:not(.ly-ripple-no-focus):focus > .ly-button-ripple > ly-hover-container { animation: btnFocusAnim infinite 1.4s 0ms; transform: scale3d(1, 1, 1); opacity: .13; } [ly-icon-button]:not(.ly-ripple-no-focus):focus > .ly-icon-button-container > [ly-ripple] > ly-hover-container { /* for ly-icon-button*/ transform: scale3d(1, 1, 1); opacity: .33; transition: all 375ms cubic-bezier(0.45, 0, 0.25, 1); } /* LyRippleMinimal */ .ly-ripple-minimal { position: relative; } .ly-ripple-minimal .ly-ripple-container { position: absolute; width: 5px; height: 5px; background: currentColor; opacity: .16; border-radius: 100%; transform: scale(0); transition: opacity ease, transform cubic-bezier(0.4, 0, 0.2, 1); pointer-events: none; } ly-drawer-container { display: flex; } ly-drawer-container .ly-drawer { position: fixed; overflow: auto; height: inherit; width: inherit; top: inherit; bottom: inherit; text-align: inherit; } ly-drawer-container ly-drawer-content { flex: 1 1; } "],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false
                },] },
    ];
    /** @nocollapse */
    LyRoot.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: LyTheme, },
    ]; };
    LyRoot.propDecorators = {
        "backgroundStyle": [{ type: HostBinding, args: ['style.background',] },],
        "colorStyle": [{ type: HostBinding, args: ['style.color',] },],
        "fontFamily": [{ type: HostBinding, args: ['style.font-family',] },],
    };
    return LyRoot;
}());
export { LyRoot };
var LyInlineText = /** @class */ (function () {
    function LyInlineText() {
    }
    LyInlineText.decorators = [
        { type: Component, args: [{
                    selector: 'inline-text',
                    template: "<ng-content></ng-content>",
                    styles: ["\n    :host {\n      vertical-align: baseline;\n    }\n  "],
                },] },
    ];
    /** @nocollapse */
    LyInlineText.ctorParameters = function () { return []; };
    return LyInlineText;
}());
export { LyInlineText };
var LyCoreModule = /** @class */ (function () {
    function LyCoreModule() {
    }
    LyCoreModule.forRoot = function () {
        return {
            ngModule: LyCoreModule,
        };
    };
    LyCoreModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    exports: [LyRoot, LyInlineText],
                    declarations: [LyRoot, LyInlineText],
                    providers: [Platform]
                },] },
    ];
    /** @nocollapse */
    LyCoreModule.ctorParameters = function () { return []; };
    return LyCoreModule;
}());
export { LyCoreModule };
//# sourceMappingURL=core.js.map